<template>
  <div>
    <div class="loading-screen" v-if="!isWhiteLabel">
      <aha-logo-loader :display-text="displayTextLogoLoader" />
    </div>
    <div class="loading-screen-white-label" v-else>
      <div>
        <aha-spinner size="lg" variant="tail" />
        <p class="mt-6">
          {{ $i18nPresenter.t('Just a moment please...') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Utils from '@/util'

export default {
  name: 'LoadingScreen',
  components: {
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    isWhiteLabel() {
      return Utils.checkWhiteLabelDomain()
    },
    displayTextLogoLoader() {
      return !!(this.currentUser && this.currentUser.id)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.loading-screen {
  background-color: #fff;
  max-height: -webkit-fill-available; // fix height in ios safari (with address bar)
  @apply fixed top-0 left-0 w-full h-full z-50 flex content-center;
  @apply flex-col justify-center items-center;
}

.loading-screen-white-label {
  background-color: #fff;
  @apply fixed top-0 left-0 w-full h-full z-50 flex content-center justify-center items-center;
}
</style>
